
<template>
    <div>
        <compFormEdit ref="bathUpdate" class="margin-layout" :formdata="getBase" v-model="formData" />
        <div class="text-right">
            <vButton theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-10" @click="cancel">返回</vButton>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { HttpGetOurWarehouseList } from "@/service/bespeak";
import { HttpWarehouseListBathUpdate } from "@/service/basicdata"
export default {
    props: ['activeid', 'querytype'],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            id: this.$route.query.id || this.activeid,
            formData: {},
            ourwarehouseList: []
        }
    },
    created() {
        // 请求仓库
        HttpGetOurWarehouseList().then(res => {
            this.ourwarehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.code + '(' + item.title + ')'
                }
            })
        })
    },
    computed: {
        getBase() {
            return [
                {
                    label: '预约类型',
                    tag: 'vSelect',
                    key: 'bookingTypeList',
                    options: [
                        { label: "加急", value: 0 },
                        { label: "普通", value: 1 },
                    ],
                    props: {
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: '单据类型',
                    tag: 'vSelect',
                    key: 'goodTypeCodeList',
                    options: [
                        { label: "FCL", value: 'FCL' },
                        { label: "LTL", value: 'LTL' },
                        { label: "Express", value: 'Express' },
                    ],
                    props: {
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'warehouseIds',
                    options: this.ourwarehouseList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                },
                {
                    label: "可约日期",
                    key: "reserveTime",
                    tag: "vDatepicker",
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    valueText: this.formData.reserveDate,
                },
                {
                    label: "可约量/天",
                    key: "totalQty",
                    tag: "vInput",
                },

            ];
        },
    },
    methods: {
        async submit() {
            const valid = await this.$refs.bathUpdate.validate()
            if (!valid) return;
            this.loading = true;
            this.formData.contextId = global.SYSID,
            this.formData.reserveStartDate = this.formData.reserveTime.split('~')[0]
            this.formData.reserveEndDate = this.formData.reserveTime.split('~')[1]
            HttpWarehouseListBathUpdate({
                ...this.formData
            }).then(res => {
                this.loading = false
                this.$Message.success(res.message);
                this.cancel()
            }).catch(err => {
                this.loading = false
                this.$Message.success(err.message);
            })
        },
        cancel() {
            this.$emit("on-close");
        }
    }
}

</script>